import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { configurationCodes } from '@/configurations/constants';
import { fetchConfiguration } from '@/configurations/actions';
import RoleCardItem from '../components/RoleCardItem';

const RoleCardItems = ({
  category,
  defaultRole,
  fetchData,
  items,
  readStatus,
}) => {
  fetch.useFetchByCode(fetchData, 'all', configurationCodes.DEFAULT_ROLE, readStatus, fetchConfig([defaultRole]));
  return (
    items.map((item, index) => (
      <RoleCardItem
        category={category}
        defaultRole={defaultRole === item.code}
        key={`roles_card_item_${item.id}`}
        role={item}
        upward={index > 4}
      />
    ))
  );
};

const mapStateToProps = ({
  configurations: { configurations },
}) => {
  const defaultRole = findResult(configurations, 'all', configurationCodes.DEFAULT_ROLE) || {
    value: { value: '' },
    readStatus: states.NONE,
  };

  return {
    readStatus: defaultRole.readStatus,
    defaultRole: defaultRole.value.value,
  };
};

const mapDispatchToProps = {
  fetchData: fetchConfiguration,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleCardItems);
